import React from 'react';
import Svg, { Circle } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

const DotIcon = ({ height = 4, width = 4, color = '#707070' }: Props) => (
  <Svg width={width} height={height} viewBox="0 0 4 4" fill="none">
    <Circle cx="2" cy="2" r="2" fill={color} />
  </Svg>
);

export default DotIcon;
